module.exports = __webpack_public_path__ + "img/bg-family-square.02fa53d8.webp";